var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.376,
    height: 20,
    viewBox: "0 0 17.376 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.127.017C10.218 0 11.302.01 12.386 0a5.191 5.191 0 001.458 3.477 5.885 5.885 0 003.533 1.491v3.356a8.853 8.853 0 01-3.5-.807 10.128 10.128 0 01-1.351-.775c-.006 2.435.01 4.867-.016 7.292a6.344 6.344 0 01-1.127 3.285 6.2 6.2 0 01-4.925 2.673 6.064 6.064 0 01-3.4-.856 6.28 6.28 0 01-3.04-4.76 13.89 13.89 0 01-.01-1.24 6.28 6.28 0 017.277-5.571c.017 1.234-.033 2.468-.033 3.7a2.867 2.867 0 00-3.657 1.77 3.313 3.313 0 00-.113 1.341 2.845 2.845 0 005.225 1.052 1.965 1.965 0 00.342-.886c.082-1.491.049-2.975.059-4.466.007-3.36-.01-6.71.016-10.059z",
    fill: "#999"
  })));
}

export default SvgIconSocialTiktok;